<div class="modal fade" *ngIf="webApi.isLoggedIn() && webApi.newVideos && webApi.newVideos.length>0" id="new-videos-modal" tabindex="-1" aria-labelledby="reportlegalityModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-md modal-dialog-centered">
      <div class="modal-content modal-popup">
        <div class="content-section newvideo-owl">
          <h3 *ngIf="user" class="mb-3">Hi {{user.first_name+ ' ' +user.last_name}}</h3>
          <p class="mb-3">Check out some new content since your last login! </p>
          <!-- <p class="mb-2">Here is our new video collection </p> -->
          <owl-carousel-o [options]="customOptions">
            <ng-template carouselSlide *ngFor="let video of webApi.newVideos">
              <div style="align-content: center" class="new-videos-carousel-item" (click)="openDetails(video.id,'newVideoBackdrop')">  
                <img style="height: 240px;width:100%"src={{getThumbUrl(video.video_thumb)}}/> 
                <button type="button" class="btn btn-sm btn-gold float-start shadow">{{video.cat | uppercase}}</button>
                <div class="video-description">

                  <p class="heading mb-0">{{video?.name | uppercase}} </p>
                  <p *ngIf="video && video?.description" class="description">{{webApi.showSmallDescription(video?.description,80)}} </p>
                </div>
              </div>  
            </ng-template>   
          </owl-carousel-o>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
      </div>
    </div>
  </div>
<ng-container *ngIf="webApi.isLoggedIn() && webApi.newVideos && webApi.newVideos.length>0">
<app-video-details modalid="newVideoBackdrop" [videoDetails]="videoDetails"></app-video-details>
</ng-container>
